<template>
  <div id="app">
    <!-- <img src="./assets/logo.png"> -->
    <router-view :key="$route.path"/>
  </div>
</template>
<script>
export default {
  name: 'App',
  mounted() {
    localStorage.setItem('dialogShow','1');
    console.log('第一次初始化');
  }
}
</script>

<style>
@import 'iconfont/css/font-awesome.min.css';
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  height: 100%;
  overflow-y: hidden;
}
.el-submenu__title{
  background: #FFF !important;
  /* color: rgb(66, 120, 249)  !important; */
  font-size: 18px !important;
}
.el-carousel__container{
  height: 400px !important;
}
ul{
  list-style: none;
}
</style>



// WEBPACK FOOTER //
// src/App.vue